import { render } from "./plagiarismModal.vue?vue&type=template&id=6cf2dc28&scoped=true"
import script from "./plagiarismModal.vue?vue&type=script&lang=js"
export * from "./plagiarismModal.vue?vue&type=script&lang=js"

import "./plagiarismModal.vue?vue&type=style&index=0&id=6cf2dc28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf2dc28"]])

export default __exports__